import { j as l } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as d } from "react";
import { I as o } from "../../../../IconBase-CxZyIWw2.js";
const s = d((i, e) => /* @__PURE__ */ l.jsx(
  o,
  {
    ref: e,
    ...i,
    image: (r) => /* @__PURE__ */ l.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...r,
        children: [
          /* @__PURE__ */ l.jsx("g", { clipPath: "url(#clip0_3410_69136)", children: /* @__PURE__ */ l.jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16M7 7V4h2v3h3v2H9v3H7V9H4V7z",
              clipRule: "evenodd"
            }
          ) }),
          /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "clip0_3410_69136", children: /* @__PURE__ */ l.jsx("path", { fill: "#fff", d: "M0 0h16v16H0z" }) }) })
        ]
      }
    )
  }
));
s.displayName = "CircleAddIcon";
export {
  s as CircleAddIcon,
  s as default
};
//# sourceMappingURL=index.js.map
